import React from 'react'
import { fullClientVersion } from '@core/Utils/clientVersion'
import { useServerConfig } from '@core/Data/ServerConfig/useServerConfig'
import { List, ListItem } from '@mobi/component-library/Base/List'

export const VersionInfo = () => {
  const config = useServerConfig()
  const gitVersionInfo = window?.TABTOUCH?.versionInfo
  const serverVersion = config ? `${config.serverVersion} (${config.serverEnvironment})` : 'Unknown'

  return (
    <>
      <List title='Version Info' variant='card'>
        <ListItem text='Server Version' contentRight={serverVersion} />
        <ListItem text='Client Version (from bundle)' contentRight={fullClientVersion} />
      </List>

      {gitVersionInfo && (
        <List title='Git Details' variant='card'>
          <ListItem text='Client Version' contentRight={gitVersionInfo.version} />
          <ListItem text='Git Commit SHA' contentRight={gitVersionInfo.gitCommitShaShort} />
          <ListItem text='User' contentRight={gitVersionInfo.gitUsername} />
          <ListItem
            text='Git Pipeline'
            contentRight={
              <a href={gitVersionInfo.gitPipelineUrl} target='_blank' rel='noreferrer'>
                {gitVersionInfo.gitPipelineIid}
              </a>
            }
          />
          <ListItem
            text='GitLab Project'
            contentRight={
              <a href={gitVersionInfo.gitProjectUrl} target='_blank' rel='noreferrer'>
                Open
              </a>
            }
          />
        </List>
      )}
    </>
  )
}
